export default __webpack_public_path__ + "static/media/icons-dashboard.dd38d7f3.svg";